export const composeValidators =
  (...validators) =>
  value =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined,
    );

/**
 * When we display values (groupes d'élèves, classes) side by side (horizontally),
 * space is divided equally. So we use a rule of thumb to know if one value is too long.
 */
export const hasEnoughSpaceForAllLabels = (
  labels: string[],
  availableChars: number = 16,
) => {
  const maxCharsPerOption = Math.floor(availableChars / labels.length);
  return !labels.some(v => v.length > maxCharsPerOption);
};
